import SubHeader from "../../components/header/SubHeader";
// import Button from "../../components/common/button/Button";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductReport, resetProductReportStatus } from "../../store/product-slice";
import Table from "../../components/common/table/Table";
import {
    getProductReportFormData,
    getProductReportTableColumns,
    getProductReportTableData,
} from "../../models/productModel";
import Form from "../../components/common/form/Form";
import { productReportSchema } from "../../schema/productSchema";

const ProductReport = () => {
    const dispatch = useDispatch();
    const { productReport: items, fetchProductReportStatus, error } = useSelector(state => state.product);

    const userRole = useSelector((state) => state.auth.selectedRole);

    const formSubmitHandler = (data) => {
        const { startDate, endDate } = data;
        const dateParams = `&startDate=${startDate}&endDate=${endDate}`;
        dispatch(fetchProductReport({ ...userRole, dateParams }));
    };

    useEffect(() => {
        dispatch(resetProductReportStatus());
    }, [dispatch]);

    const schema = productReportSchema()
    const initialData = getProductReportFormData();

    const tableColumns = getProductReportTableColumns();
    const tableData = getProductReportTableData({ items });

    return (
        <>
            <SubHeader title="Top Selling Products" />
            {/* <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader> */}
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-6">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            error={error}
                        />
                    </div>
                </div>
                {fetchProductReportStatus === "loading" && <p>Loading...</p>}
                {fetchProductReportStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchProductReportStatus === "success" &&
                    <Table className="mobile-responsive mt-7" columns={tableColumns} data={tableData} />
                }
            </div>
        </>
    )
}

export default ProductReport;